'use strict';

var productStickyElements = require('./productStickyElements');

/**
* @description Handles toggle elements
*/

var productToggler = {

    /**
     * @object
     * @description - caches dom elements used as vars and returns an object
     */
    $cache: {
        $togglerElement: $('.c-toggler__element')
    },

    /**
     * @function
     * @description - toggle element on click/tap
     */
    toggleContent: function(toglerElement, togler) {
        $(togler).toggleClass('c-toggler--expanded');
    },

    initEvents: function() {
        var _that = this;

        this.$cache.$togglerElement.on('click', function() {
            var $togglerElement = $(this),
                $togler = $togglerElement.parents('.c-toggler');

            _that.toggleContent($togglerElement, $togler);
            productStickyElements.toggleDetailsSticky();
        });
    },

    init: function() {
        this.initEvents();
    }
};

module.exports = productToggler;
